import SinglePropertyDashboardContainer from './container';

export default SinglePropertyDashboardContainer;
